export type A4Props = {
  cardOrientation: Orientation
}

export type VariantScale = {
  scale: string
  x: string
  y: string
}

export type Price = {
  display: string
  centAmount: number
  currencyCode: string
}

export type Variant = {
  name: CardSize
  title: string
  dimensions: string
  sku: string | null
  key: string
}

export enum Orientation {
  Landscape = 'landscape',
  Portrait = 'portrait',
  Square = 'square',
}

export enum CardSize {
  Standard = 'standard',
  Large = 'large',
  Giant = 'giant',
  ECard = 'ecard',
}

export type OnContinueEvent = (params: {
  variantSku: string
  envelopeSku: string
}) => Promise<void>
